// @ts-ignore
import Moment from 'react-moment';
import { useEffect, useState } from 'react';

function TableFormTemplate(props) {
    const [sortBy, setSortBy] = useState(props.sortBy);
    useEffect(() => {
        setSortBy(props.sortBy);
    }, [props.sortBy]);

    return (
        <table className='min-w-full divide-y divide-gray-200'>
            <thead className='bg-gray-50'>
            <tr className={'cursor-pointer'}>
                <th
                    onClick={(e) => {
                        props.sortClicked({ sortBy: 'name' });
                    }}
                    scope='col'
                    className='px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider'>
                    Tên biểu mẫu
                    {
                        sortBy.name == 'name' ?
                            <i className={(sortBy.order == 'desc' ? 'fas fa-sort-amount-up-alt' : 'fas fa-sort-amount-down-alt') + ' ml-1'}></i> : ''
                    }
                </th>
                <th
                    scope='col'
                    className='px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider'>
                    hành động
                </th>
                <th></th>
            </tr>
            </thead>
            <tbody className='bg-white divide-y divide-gray-200 cursor-pointer'>
            {props.data.map((item) => (
                <tr
                    className='hover:bg-gray-100'
                    key={item.id}
                   >
                    <td className='px-6 py-4 whitespace-nowrap'>
                        <div className='text-sm text-gray-900 text-left'>
                            {item.name || ''}
                        </div>
                    </td>
                    <td className='px-6 py-4 whitespace-nowrap text-left text-sm'>
                        <div className='flex justify-end'>
                            <div
                                className='text-blue-700 hover:text-blue-800 font-semibold cursor-pointer'
                                onClick={(e) => {
                                    props.updateClicked(e, item);
                                }}>
                                <i className='fas fa-pen mr-2' />
                                Chỉnh sửa
                            </div>
                            <span className='mx-2'>/</span>
                            <div
                                className='text-green-700 hover:text-green-800 font-semibold cursor-pointer'
                                onClick={(e) => {
                                    props.downloadClick(e, item);
                                }}>
                                <i className='fas fa-arrow-down mr-2' />
                                Tải về
                            </div>
                            <span className='mx-2'>/</span>
                            <div
                                className='text-red-600 hover:text-red-700 font-semibold cursor-pointer'
                                onClick={(e) => {
                                    props.deleteClicked(e, item.id);
                                }}>
                                <i className='far fa-trash-alt mr-2' />
                                Xóa
                            </div>
                        </div>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default TableFormTemplate;
